import { render, staticRenderFns } from "./TransporterTab.vue?vue&type=template&id=62830d02&scoped=true&"
import script from "./TransporterTab.vue?vue&type=script&lang=js&"
export * from "./TransporterTab.vue?vue&type=script&lang=js&"
import style0 from "./TransporterTab.vue?vue&type=style&index=0&id=62830d02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62830d02",
  null
  
)

export default component.exports